import React, { useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import {
  migrateToTwoRootArchitecture,
  verifyTwoRootArchitecture,
  cleanupLegacyRootCollections,
} from '../../Services/adminMigration';

const AdminDataMigration = () => {
  const [busy, setBusy] = useState('');
  const [result, setResult] = useState(null);

  const run = async (name, action) => {
    setBusy(name);
    try {
      const response = await action();
      setResult(response);
      toast.success(name === 'cleanup'
        ? 'Anciennes collections supprimées.'
        : 'Opération terminée.');
    } catch (error) {
      toast.error(error?.message || 'L’opération a échoué.');
    } finally {
      setBusy('');
    }
  };

  const cleanup = async () => {
    const confirmation = window.prompt(
      'Cette opération supprime définitivement les anciennes collections racines. Tapez DELETE_LEGACY_ROOTS pour confirmer.',
    );
    if (confirmation !== 'DELETE_LEGACY_ROOTS') return;
    await run('cleanup', cleanupLegacyRootCollections);
  };

  return (
    <Page>
      <Card>
        <h1>Migration Firestore vers deux collections racines</h1>
        <p>
          Cette page est temporaire. Elle copie les données vers <strong>users</strong> et
          <strong> demands</strong>, vérifie les comptes, puis permet le nettoyage.
        </p>
        <Warning>
          Avant le nettoyage, exportez Firestore et vérifiez l’application sur un canal Preview.
          Ne supprimez jamais les anciennes collections avant que la vérification affiche
          <strong> verified: true</strong>.
        </Warning>
        <Actions>
          <button disabled={Boolean(busy)} onClick={() => run('migrate', migrateToTwoRootArchitecture)}>
            {busy === 'migrate' ? 'Migration…' : '1. Copier les données'}
          </button>
          <button disabled={Boolean(busy)} onClick={() => run('verify', verifyTwoRootArchitecture)}>
            {busy === 'verify' ? 'Vérification…' : '2. Vérifier la migration'}
          </button>
          <button className="danger" disabled={Boolean(busy)} onClick={cleanup}>
            {busy === 'cleanup' ? 'Nettoyage…' : '3. Supprimer les anciennes racines'}
          </button>
        </Actions>
        {result && <pre>{JSON.stringify(result, null, 2)}</pre>}
      </Card>
    </Page>
  );
};

export default AdminDataMigration;

const Page = styled.main`
  max-width: 1050px;
  margin: 0 auto;
  padding: 2rem 1rem 7rem;
`;
const Card = styled.section`
  background: #fff;
  border: 1px solid #e6ded3;
  border-radius: 28px;
  padding: clamp(1.25rem, 3vw, 2.5rem);
  box-shadow: 0 18px 50px rgba(20, 16, 10, .07);
  h1 { margin-top: 0; }
  pre {
    overflow: auto;
    background: #111;
    color: #fff;
    padding: 1rem;
    border-radius: 16px;
    margin-top: 1.25rem;
  }
`;
const Warning = styled.div`
  background: #fff7e8;
  border: 1px solid #ead2a7;
  border-radius: 16px;
  padding: 1rem;
  margin: 1rem 0;
`;
const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: .75rem;
  button {
    border: 0;
    border-radius: 999px;
    padding: .9rem 1.2rem;
    font-weight: 800;
    cursor: pointer;
    background: #111;
    color: #fff;
  }
  button:disabled { opacity: .5; cursor: wait; }
  .danger { background: #a51f1f; }
`;
